export function calcMontageTotals(cart) {
    var _a, _b, _c, _d;
    const montageCost = ((_b = (_a = window === null || window === void 0 ? void 0 : window.calcData) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.montageCost) || 400;
    const montageText = ((_d = (_c = window === null || window === void 0 ? void 0 : window.calcData) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.montageText) || 'Монтаж воздуховода';
    const obj = cart.reduce((acc, it) => {
        if (it.type !== 'airduct')
            return acc;
        acc.count += it.count;
        if (!isNaN(+it.square)) {
            acc.totalPrice += (+it.square * it.count * montageCost);
            acc.square += +it.square * it.count;
        }
        return acc;
    }, { count: 0, square: 0, totalPrice: 0 });
    return Object.assign({ text: montageText, base: montageCost }, obj);
}
